import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

type LoadingReconhecimentoProps = {
  open: boolean;
};

export const LoadingReconhecimento: React.FC<LoadingReconhecimentoProps> = ({
  open,
}) => {
  return (
    <MUI.Modal
      open={open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(4px)",
        zIndex: 9999,
        position: "fixed",
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
      }}
      disableScrollLock
    >
      <MUI.Card
        sx={{
          p: 4,
          maxWidth: 500,
          width: "90%",
          textAlign: "center",
          borderRadius: 3,
          boxShadow: 24,
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <MUI.Box sx={{ mb: 3 }}>
          <MUIcons.Search
            sx={{
              fontSize: 64,
              color: "primary.main",
              "@keyframes pulse": {
                "0%": { transform: "scale(1)", opacity: 1 },
                "50%": { transform: "scale(1.1)", opacity: 0.7 },
                "100%": { transform: "scale(1)", opacity: 1 },
              },
              animation: "pulse 2s infinite",
            }}
          />
        </MUI.Box>

        <MUI.Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}
        >
          Processando Reconhecimento Facial
        </MUI.Typography>

        <MUI.Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Analisando a imagem no banco de dados de mandados e faces...
        </MUI.Typography>

        <MUI.LinearProgress
          sx={{
            mb: 2,
            height: 8,
            borderRadius: 1,
            backgroundColor: "grey.200",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "primary.main",
            },
          }}
        />

        <MUI.Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontStyle: "italic" }}
        >
          Aguarde, isso pode levar alguns segundos...
        </MUI.Typography>
      </MUI.Card>
    </MUI.Modal>
  );
};
